/*
 * Ariser: visual mobile menu tabs (snippets/ariser-mobile-menu.liquid).
 *
 * - Tapping a department tab shows its panel of picture tiles.
 * - The server marks the tab for the department of the current page as default.
 *   If none matches, the last tab used in this session is restored, else the first tab.
 */
(function () {
  'use strict';
  var KEY = 'ariser-mm-tab';

  function activate(root, index, remember) {
    root.querySelectorAll('.ariser-mm__tab').forEach(function (t) {
      var on = t.getAttribute('data-tab') === String(index);
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) { /* older browsers */ } }
    });
    root.querySelectorAll('.ariser-mm__panel').forEach(function (p) {
      p.classList.toggle('is-on', p.getAttribute('data-panel') === String(index));
    });
    if (remember) { try { sessionStorage.setItem(KEY, String(index)); } catch (e) { /* storage blocked */ } }
  }

  function init(root) {
    if (!root || root.hasAttribute('data-ariser-mm-ready')) return;
    root.setAttribute('data-ariser-mm-ready', '1');
    var tabs = root.querySelectorAll('.ariser-mm__tab');
    if (!tabs.length) return;

    var serverDefault = root.querySelector('.ariser-mm__tab.is-on');
    if (!serverDefault) {
      var saved = null;
      try { saved = sessionStorage.getItem(KEY); } catch (e) { /* ignore */ }
      var exists = saved && root.querySelector('.ariser-mm__tab[data-tab="' + saved + '"]');
      activate(root, exists ? saved : tabs[0].getAttribute('data-tab'), false);
    }

    root.addEventListener('click', function (evt) {
      var tab = evt.target.closest('.ariser-mm__tab');
      if (!tab) return;
      evt.preventDefault();
      activate(root, tab.getAttribute('data-tab'), true);
    });
  }

  function boot() { document.querySelectorAll('[data-ariser-mm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
